(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rt-pdp-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rt-size-guide')) {
  customElements.define('rt-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.trigger = this.querySelector('.rt-size-guide__trigger');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.ready = true;
      const lookup = this.querySelector('[data-size-lookup]');
      const chart = this.querySelector('.rt-size-guide__chart');
      if (lookup && chart) {
        lookup.addEventListener('change', () => {
          const rows = Array.from(chart.querySelectorAll('[data-guide-size]'));
          const selected = rows.find(row => row.dataset.guideSize === lookup.value);
          rows.forEach(row => row.classList.toggle('is-selected', row === selected));
          const result = this.querySelector('[data-size-result]');
          result.hidden = !selected;
          if (selected) {
            this.querySelector('[data-size-diameter]').textContent = selected.cells[1].textContent;
            this.querySelector('[data-size-circumference]').textContent = selected.cells[2].textContent;
            chart.open = false;
          } else {
            chart.open = true;
          }
        });
      }
      this.trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.dialog.open) return;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        this.querySelector('[data-size-close]').focus();
      });
      this.querySelector('[data-size-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.trigger.focus({preventScroll:true});
      });
    }
    disconnectedCallback() {
      if (this.dialog && this.dialog.open) {
        this.dialog.close();
        document.body.style.overflow = this.previousOverflow || '';
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
